import type React from "react";
import {Button, Paper, Stack, Typography} from "@mui/material";

type TaxonomyMergeBarProps = {
    /** Names of the ticked categories, in tree order */
    selected: string[];
    /** Name of their parent; unset until one is ticked */
    parentName?: string;
    onCancel: () => void;
    onMerge: () => void;
};

/** Shown on the canvas in merge mode: what is ticked so far, and the merge / cancel buttons. */
export const TaxonomyMergeBar: React.FC<TaxonomyMergeBarProps> = ({selected, parentName, onCancel, onMerge}) => {
    const count = selected.length;
    return (
        <Paper elevation={4} sx={{px: 2, py: 1.25, borderRadius: '12px'}}>
            <Stack direction="row" alignItems="center" gap={2}>
                <Typography variant="body2">
                    {count === 0
                        ? 'Tick 2 or more categories under the same parent to merge them.'
                        : `${count} selected under ${parentName}${count < 2 ? ': tick at least one more.' : '.'}`}
                </Typography>
                <Button size="small" onClick={onCancel}>Cancel</Button>
                <Button size="small" variant="contained" onClick={onMerge} disabled={count < 2}>
                    {count < 2 ? 'Merge' : `Merge ${count}`}
                </Button>
            </Stack>
        </Paper>
    );
};
